import { render, staticRenderFns } from "./DetailedResultComponent.vue?vue&type=template&id=2a5fdcd6&scoped=true"
import script from "./DetailedResultComponent.vue?vue&type=script&lang=js"
export * from "./DetailedResultComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailedResultComponent.vue?vue&type=style&index=0&id=2a5fdcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5fdcd6",
  null
  
)

export default component.exports